/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scenting_Grade_SubtitleInputs */

const vi_scenting_grade_subtitle = /** @type {(inputs: Scenting_Grade_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục phân loại riêng của kho lấy hương.`)
};

/**

* @param {Scenting_Grade_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scenting_grade_subtitle = /** @type {((inputs?: Scenting_Grade_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scenting_Grade_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scenting_grade_subtitle(inputs)
});